import React from "react";
import { IconButton } from "@SeemplicityDev/shared";

interface PageActionsProps {
  onMute: () => void;
  onDownload: () => void;
  onExit: () => void;
  isMuted: boolean;
}

const PageActions: React.FC<PageActionsProps> = ({
  onMute,
  onDownload,
  onExit,
  isMuted,
}) => {
  return (
    <div className="actions-wrapper">
      <IconButton
        isIcon={isMuted ? "seem-icon-mute" : "seem-icon-unmute"}
        className={"action-button silence-button"}
        onClick={() => {
          console.log("muting audio!!");
          onMute();
        }}
      />
      <IconButton
        isIcon={"seem-icon-download"}
        className={"action-button download-button"}
        onClick={onDownload}
      />{" "}
      <IconButton
        isIcon={"seem-icon-close"}
        className={"action-button exit-button"}
        onClick={onExit}
      />
    </div>
  );
};

export default PageActions;
